import { Action } from "@ngrx/store";

export const MENU_EXPAND = 'admin menu expand';
export const MENU_COLLAPSE = 'admin menu collapse';

export class MenuExpand implements Action {
    readonly type = MENU_EXPAND;
}

export class MenuCollapse implements Action {
    readonly type = MENU_COLLAPSE;
}

export type MenuActions = MenuExpand | MenuCollapse;


// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/shared/menu.action.ts